//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Avatar from 'vue-avatar';
import moment from 'moment-timezone';

export default {
  components: {
    'avatar': Avatar,
  },
  props: {
    contentUuid: String,
    contentType: String,
    comment: Object,
    child: Boolean,
    client: Object, // Instantiated apollo client.
    authorUuid: String,
    siteUuid: String,
  },
  data() {
    return {
      comments: this.comment.comments || [],
      isOpen: false,
      relative: moment.unix(this.comment.created / 1000).fromNow(),
    };
  },
  methods: {
    addComment(event) {
      this.toggle();
      const comment = event.comment;
      this.comments.push({
        uuid: comment.uuid,
        body: comment.body,
        contentUuid: this.contentUuid,
        contentType: this.contentType,
        comments: comment.comments,
        author: comment.author,
        created: comment.created
      });
    },
    toggle: function() {
      this.isOpen = !this.isOpen
    },
    fetchIframely: function() {
      const content = this.comment.body;
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const replacement = content.replace(urlRegex, function(url) {
        return `<a data-iframely-url href="${url}"></a>`;
      });
      this.comment.body = replacement;
      setTimeout(function() {
        window.iframely.load();
      }, 100);
    }
  },
  mounted() {
    if (window.iframely !== undefined) {
      this.fetchIframely();
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/molecules/comment/comment.vue